export default "__VITE_ASSET__25616042__"